export default __webpack_public_path__ + "static/derrick2-878938180be17fab039c6cb98cdf1eb7.jpeg";